import { withInstall } from '@vuesax-alpha/utils'
import Popconfirm from './src/popconfirm.vue'

export const VsPopconfirm = withInstall(Popconfirm)
export default VsPopconfirm

export * from './src/popconfirm'
